import React from 'react';
import {
    goalCurrentOptionStyle,
    goalCurrentTextStyle,
    goalOptionStyle,
    goalsMenuStyle,
    goalTextStyle
} from './AirtimePlanningStyles';

const PlanGoals = ({ goals, currentGoal, updateGoal }) => {
    const changeGoal = (event, idx) => {
        if (idx !== currentGoal) {
            updateGoal(idx);
            event.currentTarget.style.backgroundColor = '#FFFFFF';
        }
    };

    const handleHoverEnter = (event, idx) => {
        if (idx !== currentGoal) {
            event.currentTarget.style.backgroundColor = 'rgba(20,251,255,0.15)';
        }
    };

    const handleHoverLeave = (event) => {
        event.currentTarget.style.backgroundColor = '#FFFFFF';
    };

    return (
        <div style={goalsMenuStyle}>
            <div style={{ height: 10 }} />
            {goals?.map((g, i) => (
                <div
                    onClick={(e) => changeGoal(e, i)}
                    key={`plan-goal${i}`}
                    style={
                        i === currentGoal
                            ? goalCurrentOptionStyle
                            : goalOptionStyle
                    }
                    onMouseEnter={(e) => handleHoverEnter(e, i)}
                    onMouseLeave={(e) => handleHoverLeave(e)}
                >
                    <span
                        style={
                            i === currentGoal
                                ? goalCurrentTextStyle
                                : goalTextStyle
                        }
                    >
                        {g?.name}
                    </span>
                </div>
            ))}
        </div>
    );
};

export default PlanGoals;
